import classNames from "classnames";
import { useWebGalleryStore } from ".";
import {
  isAudio,
  isCheckerboardImage,
  isImage,
  isMsFile,
  isRendition,
} from "../types";
import objectFitImages from "object-fit-images";

export const useDetermineImageClass = (asset: Asset) => {
  const store = useWebGalleryStore();

  objectFitImages();

  const isImageBase = !store.zoomLevel || store.zoomLevel < 500;
  const isCheckerboardBackground =
    isRendition(asset) || isCheckerboardImage(asset);
  const isScaleDown = isMsFile(asset) || isAudio(asset);

  if ((isImage(asset) || isRendition(asset)) && isCheckerboardBackground) {
    return classNames("image-base--max_width", "checkerboard-background");
  }
  return classNames({
    "image-base": isImageBase && !isScaleDown,
    "checkerboard-background": isCheckerboardBackground,
    "image-base--scale_down": isImageBase && isScaleDown,
    "image-base--max_width": !isImageBase,
  });
};
